import { SET_COMPANIES } from '../types';

const initialState = {
  companies: [],
};

const companies = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANIES:
      return {
        ...state,
        companies: action.payload,
      };
    default:
      return state;
  }
};

export default companies;
